import { c as _c } from "react/compiler-runtime";
import { useTransition } from "react";
import { useParams } from "next/navigation";
import { useLocale } from "next-intl";
import { routing, usePathname, useRouter } from "@/i18n/routing";
import useFramerMotion, { LazyMotion, m } from "@/hooks/useFramerMotion";
const LanguageSwitcher = () => {
  const $ = _c(13);
  const framerMotionFeatures = useFramerMotion();
  const [isPending, startTransition] = useTransition();
  const locale = useLocale();
  const pathname = usePathname();
  const params = useParams();
  const locales = routing.locales;
  const router = useRouter();
  let t0;
  if ($[0] !== params || $[1] !== pathname || $[2] !== router) {
    t0 = locale_0 => {
      startTransition(() => {
        router.replace({
          pathname,
          params
        }, {
          locale: locale_0
        });
      });
    };
    $[0] = params;
    $[1] = pathname;
    $[2] = router;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const changeLocale = t0;
  let t1;
  if ($[4] !== changeLocale || $[5] !== isPending || $[6] !== locale) {
    t1 = locales.map(currentLocale => {
      const isActive = locale === currentLocale;
      return <button onClick={() => changeLocale(currentLocale)} type="button" key={currentLocale} className={`relative font-secondary font-medium uppercase transition-all hover:text-mint ${isActive ? "text-mint" : ""} ${isPending ? "pointer-events-none opacity-30" : ""}`}>{currentLocale}{isActive && <m.div layoutId="langActiveItem" transition={{
          type: "spring",
          bounce: 0.3,
          duration: 0.6
        }} className="absolute bottom-0.5 h-[2px] w-full bg-mint" />}</button>;
    });
    $[4] = changeLocale;
    $[5] = isPending;
    $[6] = locale;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <div className="flex gap-4">{t1}</div>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== framerMotionFeatures || $[11] !== t2) {
    t3 = <LazyMotion features={framerMotionFeatures}>{t2}</LazyMotion>;
    $[10] = framerMotionFeatures;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default LanguageSwitcher;